export const isPremiumPlan = (plan) =>
  String(plan || "")
    .trim()
    .toLowerCase() === "premium";
